module.exports = __webpack_public_path__ + "static/img/Beats_Pill.ecb54399.jpg";